export default __webpack_public_path__ + "static/media/btn smallest (2).a89f1858.svg";